var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSnsFacebookOldFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_sns_facebook_old_filled_svg__clip0_37861_449406)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.428 10.069h-1.306c-1.285 0-1.686.849-1.686 1.719v2.063h2.87l-.458 3.18h-2.412v7.69a9.811 9.811 0 01-3.235 0v-7.69h-2.627v-3.18H14.2v-2.424c0-2.758 1.545-4.281 3.91-4.281 1.132 0 2.317.215 2.317.215v2.708zm3.498-8.054H8.075a6.06 6.06 0 00-6.06 6.06v15.85a6.06 6.06 0 006.06 6.06h15.85a6.06 6.06 0 006.06-6.06V8.075a6.06 6.06 0 00-6.06-6.06z",
    fill: "#1877F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_sns_facebook_old_filled_svg__clip0_37861_449406"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
}

export default SvgIconSnsFacebookOldFilled;